import { LikedVideos, WatchLater, Playlists } from "../../Components";

export const Library = () => {
  return (
    <>
      {/* <History /> */}
      <LikedVideos />
      <WatchLater />
      <Playlists />
    </>
  );
};
